/**
 * @module FE-CU55_Sorry画面
 */
import Header from '../../components/header/Header';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU55';

export default {
  name: 'Sorry',
  components: {
    Header,
    PCFooter,
  },
  data() {
    return {
      sorryType: 0,
      timeId: 0,
      msgs: [
        {
          id: 1,
          // #35230 Sorry画面の文言は、[ただいまシステムにつながりづらい状況です。]が正解 // [ ただいまメンテナンス中です。] は誤り
          msgJa: [
            'ただいまシステムにつながりづらい状況です。',
            'ご利用の皆様にはご迷惑をおかけし、申し訳ございません。',
            '15秒後に、ログイン画面へ移動します。自動的に移動しない方は',
            'こちら',
            'をクリックしてください。',
          ],
          msgEn: [
            'This page cannot be displayed.',
            'We are very sorry for this inconvenience.',
            'Thank you for your understanding.',
            'You will be redirected to the login screen after 15 seconds.\n Please ',
            'click here',
            ' if you are not redirected automatically.',
          ],
        },
        {
          id: 2,
          msgJa: [
            'お使いのブラウザは未対応のためご利用いただけません。',
            '動作環境は以下の通りです。',
          ],
          msgEn: ['It does not support your browser.', 'The operating environment is as follows.'],
          environment: [
            {
              browser: 'Google Chrome',
              os: 'Windows、Android、Mac OS、iOS、iPadOS',
            },
            {
              browser: 'Microsoft Edge',
              os: 'Windows',
            },
            {
              browser: 'Safari',
              os: 'Mac OS、iOS、iPadOS',
            },
          ],
        },
        {
          id: 3,
          msgJa: [
            'JavaScriptが無効です。',
            '当サイトの利用にはJavaScriptの有効化が必要です。',
            '15秒後に、ログイン画面へ移動します。自動的に移動しない方は',
            'こちら',
            'をクリックしてください。',
          ],
          msgEn: [
            'JavaScript is invalid.',
            'Please enable javascript to view this site.',
            '',
            'You will be redirected to the login screen after 15 seconds.\n Please ',
            'click here',
            ' if you are not redirected automatically.',
          ],
        },
        {
          id: 4,
          msgJa: [
            '指定されたページは存在しません。大変申し訳ございませんが、お探しのページは削除されたかファイル名が間違っている可能性があります。アドレスを確認してください。',
            '',
            '15秒後に、ログイン画面へ移動します。自動的に移動しない方は',
            'こちら',
            'をクリックしてください。',
          ],
          msgEn: [
            "The page you specified does not exist. We're sorry, but the page you are looking for may have been deleted or the file name may be incorrect. Please check the address.",
            '',
            '',
            'You will be redirected to the login screen after 15 seconds.\n Please ',
            'click here',
            ' if you are not redirected automatically.',
          ],
        },
      ],
    };
  },
  /** @type {Methods} */
  methods: {
    /**
     * ログアウト
     */
    async logout() {
      this.clickStop();
      await this.$_APP_CU0202();
    },
    /**
     * 自動ログアウト
     */
    autoLogout() {
      if (this.timeId) {
        this.clickStop();
      }

      this.timeId = setTimeout(() => {
        this.logout();
      }, 15 * 1000);
    },
    /**
     * 自動ログアウトタイマー停止
     */
    clickStop() {
      clearTimeout(this.timeId);
    },
  },
  mounted: function () {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    //const agent = window.navigator.userAgent;
    //const isChrome = agent.indexOf('Chrome') !== -1;
    //const isSafari = agent.indexOf('Safari') !== -1;
    //const isEdge = agent.indexOf('Edge') !== -1;
    //if (isChrome || isSafari || isEdge) {
    //  this.autoLogout();
    //}

    // this.sorryType is
    // 0: ただいまシステムにつながりづらい状況です
    // 1: お使いのブラウザは未対応
    // 2: JavaScriptが無効
    // 3: 指定されたページは存在しません

    if (this.$route.meta.otherUrlFlag) {
      // 存在しないページへアクセスした場合
      this.sorryType = 3;
    } else {
      this.sorryType = Number(this.$store.state.sorryType);
    }
    // 自動ログアウトでやりたかったことは
    // 対象外ブラウザのアクセスの場合、実行させたくなかった。
    // 従来方法では、スマホアプリでSorry画面を開いたときに実行しなくなる。。
    // 表示しているメッセージが15秒…の表示がある時実行すればいい。。
    if (this.sorryType === 0 || this.sorryType === 3) {
      // JavaScriptが無効の時はpublic\index.html <noscript> タグで実現
      // 他は、念のためログアウトして、ログインページへ遷移
      this.autoLogout();
    }
  },
  beforeRouteLeave(_to, _from, next) {
    this.clickStop();
    next();
  },
};
